import { getCompanyEntityAction, getCompanySuppliersAction } from '../../../../v2/APIs/action';
import * as Sentry from '@sentry/react';
import {
  SET_SUPPLIERS,
  SET_SELECTED_SUPPLIER,
  SET_SELECTED_ENTITY,
  SET_LOADING,
  SET_ERROR,
  CLEAR_ENTITY,
  SET_ENTITY,
  RESET_SUPPLIERS
} from '../../../Reducers/Entity/EntityReducer';

export const setSuppliers = (suppliers) => ({
  type: SET_SUPPLIERS,
  payload: suppliers,
});

export const setSelectedSupplier = (supplierId) => ({
  type: SET_SELECTED_SUPPLIER,
  payload: supplierId,
});


export const setSelectedEntity = (entityId) => ({
  type: SET_SELECTED_ENTITY,
  payload: entityId,
});

export const setEntity = (entityData) => ({
  type: SET_ENTITY,
  payload: entityData,
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const clearEntity = () => ({
  type: CLEAR_ENTITY,
});
export const resetSuppliers = () => ({
  type: RESET_SUPPLIERS,
});

// Legacy compatibility exports
export const resetEntityState = clearEntity;

// Shared guard for entity identifiers (company_esi_id, supplier_id, esi_id,
// firm_role_id, ...). Used at API call sites to prevent firing requests with
// empty/blanked IDs (PLAT-10408/10483/10484). Also rejects the string forms
// "undefined"/"null" that leak in via `?id=${value}` interpolation.
export const isValidEntityId = (v) =>
  v !== undefined &&
  v !== null &&
  v !== '' &&
  v !== 'undefined' &&
  v !== 'null';

export const fetchSuppliers = (module = 'default', params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error, message } = await getCompanySuppliersAction(module, params);
      if (!error && data && Array.isArray(data)) {
        dispatch(setSuppliers(data));
      } else {
        Sentry.captureMessage('fetchSuppliers failed', {
          level: 'warning',
          tags: { module: 'common', flow: 'fetchSuppliers' },
          extra: { module, message },
        });
        dispatch(setError(message || 'Failed to fetch entity data'));
      }
    } catch (err) {
      Sentry.captureException(err, {
        tags: { module: 'common', flow: 'fetchSuppliers' },
        extra: { module },
      });
      dispatch(setError(err.message || 'An error occurred'));
    }
  };
};

export const fetchEntity = (company_id ,manufacturer_id, module_name = 'ALL_MODULES') => {
  return async (dispatch) => {
    try {
      dispatch(clearEntity());
      dispatch(setLoading(true));
      const params = { manufacturer_id, module_name, company_id };
      const { data, error, message } = await getCompanyEntityAction(params);
      if (!error && data && Array.isArray(data)) {
        dispatch(setEntity(data));
      } else {
        Sentry.captureMessage('fetchEntity failed', {
          level: 'warning',
          tags: { module: 'common', flow: 'fetchEntity' },
          extra: { company_id, manufacturer_id, module_name, message },
        });
        dispatch(setError(message || 'Failed to fetch entity data'));
      }
    } catch (err) {
      Sentry.captureException(err, {
        tags: { module: 'common', flow: 'fetchEntity' },
        extra: { company_id, manufacturer_id, module_name },
      });
      dispatch(setError(err.message || 'An error occurred'));
    }
  };
};